/*-------------------------------------------------------------------
							ページ内Fadein/outお買い物カゴ CSS版
							2018年8月9日:LoadをiframeからAjax化
/*--------------------------------------------------------------------*/

$(function(){
	var csrf = $("#csrf").val();

	/*	ページの下部にHTML追加*/
	$("body").append("<!-- フローティングお買い物カゴ--><input type='hidden' id='cart_addr' value='https://www.tirakita.com/cgi-bin/phpcart5/phpcart5.php?action=regist_floating&csrf="+csrf+"&code='><div id='floatWindow_back_css'></div><div id='floatWindow_css'><div id='floatWindow2_css'><dl><dt>カートに商品が入りました</dt><dd><div id='floatWindow_cart_view_css'></div></dd>    </dl></div></div>");

	var flo = $("#floatWindow_css");
	var flo2 = $("#floatWindow_css,#floatWindow_back_css");
	var clear_page = "https://www.tirakita.com/sys/index.html";

	/*フォームがクリックされた時の処理*/
	$(".cart_form_submit").click(function(){

		var form_id_str = "#"+$(this).parent().attr("id");
		var rental = $(this).data("rental");

		//賑わいポップアップを消す
		$("#ajax_ad_popup").empty();

		//レンタルの時、レンタル日が入ってるかチェック
		var tmp = $(form_id_str+" .rental").val();
		if(tmp == 1){
			var str='';
			if(!$("#rental_start").val()){
				str = "レンタル開始日が入っていません";
			}
			if(!$("#rental_end").val()){
				str = "レンタル終了日が入っていません";
			}
			if(str){
				alert(str);
				return false;
			}
		}

	 	//読み込みアドレスの確定
		var src = $("#cart_addr").val()+$(form_id_str+" .code").val();

		var tmp = $(form_id_str+" .unit").val();
		if(tmp) src = src +"&unit="+tmp;

		var csrf = $("#csrf").val()
		if(csrf) src = src +"&csrf="+csrf;

		var tmp = $(form_id_str+" .option_id").val();
		if(tmp) src = src +"&option_id="+tmp;

		var tmp = $(form_id_str+" .rem").val();
		if(tmp) src = src +"&rem="+tmp;

		//レンタルの時、レンタル開始日などを入れる
		var tmp = $(form_id_str+" .rental").val();
		if(tmp == 1){
			var tmp = $("#rental_start").val();
			if(tmp) src = src +"&rental_start="+tmp;

			var tmp = $("#rental_end").val();
			if(tmp) src = src +"&rental_end="+tmp;
		}

		var csrf = $("#csrf").val();
		if(csrf) src = src +"&csrf="+csrf;


		//読み込み&アニメ
		var flo = $("#floatWindow_css");
		flo.show();
		flo.css('top','-500px');

		$("#floatWindow_cart_view_css").html("");
		$("#floatWindow_cart_view_css").load(src);
		$("#floatWindow_back_css").fadeIn("normal");

		flo.css({
		    'top' : '0px' ,
		});

	  return false;
	});



	/*クリックされた時の処理*/
  $("a.open_css,a.openagain_css,a.open_float_css,a.open_css201711").click(function(){

		$('#header_category').css("z-index","0");

	 	//読み込みアドレスの確定
		var src = $("#cart_addr").val()+$(this).attr("href");
	
		var token = $("#token").val()
		if(token) src = src +"&token="+token;

		if($(this).next().val()){
			console.log($(this).next().val());
			src = src + "&rem="+$(this).next().val();
		}

		//読み込み&アニメ
		flo.show();
		flo.css('top','-500px');
		$("#floatWindow_cart_view_css").html("");
		$("#floatWindow_cart_view_css").load(src);
		$("#floatWindow_back_css").fadeIn("normal");
		flo.css({
		    'top' : '0px' ,
		});

    return false;
  })


	//他のところをクリックしたら
	$("body,#floatWindow_back_css").click(function(){
		if (flo2.is(':visible')) {
			flo.css('top','0px');
			if($("#floatWindow_cart_view_css").attr("src") != clear_page){
				$("#floatWindow_cart_view_css").attr("src",clear_page);
			}
			flo2.fadeOut("fast");
			$('#header_category').css("z-index","3");
		}
	});

	//スクロールされたらウィンドウ消す
	$(window).scroll(function () {
		//スクロールさせてもお買い物かごを消さないフラグ
		var f = $("#floationg_cart_scroll_no_fade_out").val();

		if(!f){
			if (flo2.is(':visible')) {
				flo.css('top','0px');
				if($("#floatWindow_cart_view_css").attr("src") != clear_page){
					$("#floatWindow_cart_view_css").attr("src",clear_page);
				}
				flo2.fadeOut("fast");
				$('#header_category').css("z-index","3");
			}
		}
	});


});

